<template>
  <v-card class="rsl-fixed-height">
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('CASES.START_CASE.SEARCH_TEXT')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="availableProcesses"
      :items-per-page="25"
      :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
      :search="search"
      class="elevation-1 mx-3 mb-3"
      item-key="id"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      loading-text="Loading... Please wait"
      :loading="loading"
    >
      <template slot="item.actions" slot-scope="row">
        <v-btn
          small
          class="mr-2"
          color="success"
          @click="startProcess(row.item)"
        >
          {{ $t('CASES.START_CASE.BTNS.START') }}
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="startDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ startTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ startText }}</div>
            <v-text-field v-model="caseLabel" :label="$t('CASES.FIELDS.CASE_LABEL')"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="startDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmStart({processKey, version})"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import $ from 'jquery';
  import { mapGetters } from 'vuex';
  export default {
    name: 'startnewcase',
    computed: {
      ...mapGetters(['availableProcesses', 'instanceId', 'taskId', 'candidateGroups', 'candidateUsers', 'newCaseId', 'allGroups', 'allUsersSpecial', 'formKey'])
    },
    data: function() {
      return {
        loading: false,
        startDialog: false,
        startTitle: '',
        startText: '',
        processKey: '',
        processId: '',
        processName: '',
        version: '',
        caseLabel: '',
        search: '',
        sortBy: '',
        sortDesc: false,
        headers: [
          {
            text: this.$t('CASES.FIELDS.PROCESS_NAME'),
            align: 'start',
            sortable: true,
            value: 'name',
          },
          { text: this.$t('CASES.FIELDS.DESC'), value: 'description' },
          { text: this.$t('CASES.FIELDS.PROCESS_VERSION'), value: 'version' },
          { text: this.$t('CASES.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        snack: false,
        snackColor: '',
        snackText: ''
      }
    },
    created() {
      this.loading = true;
      this.$store.dispatch('getProcesses').then( () => {
        this.loading = false;
        // Apply sort field and order
        let field = this.$store.state.startCaseSortField;
        let sort = this.$store.state.startCaseSortOrder;
        if(field == null) {
          this.sortBy = 'name';
          this.sortDesc = false;
        }else if (sort == 'none') {
          this.sortBy = '';
          this.sortDesc = false;
        }else {
          this.sortBy = field;

          if(sort == 'descending') {
            this.sortDesc = true;
          }else {
            this.sortDesc = false;
          }
        }
        // Remove previous click events
        $('.text-start.sortable').off();
        // Add new click events for storing order
        let ref = this;
        $('.text-start.sortable').click(function() {
          let column = $(this)[0].firstChild.innerHTML;
          let order = $(this).attr('aria-sort');
          
          for(let i = 0; i < ref.headers.length; i++) {
            if(column == ref.headers[i].text) {
              ref.$store.commit('setStartCaseSortField', ref.headers[i].value);
              ref.$store.commit('setStartCaseSortOrder', order);
            }
          }
        });
      });

      // Get all groups
      this.$store.dispatch('getAllGroups');
      // Get all users
      this.$store.dispatch('getAllUsersSpecial');
    },
    methods: {
      startProcess(item) {
        this.startTitle = this.$t('CASES.START_CASE.TITLE');
        this.startText = this.$t('CASES.START_CASE.DESC') + ' ' + item.name;
        this.processKey = item.key;
        this.version = item.version;
        this.processId = item.id;
        this.processName = item.name;
        this.caseLabel = item.caseLabel;
        this.startDialog = true;
      },
      async confirmStart(item) {
        this.startDialog = false;
        let payload = {
          'key': item.processKey,
          'caseLabel': this.caseLabel,
          'currentUser': this.$store.state.currentUser,
          'currentUserFullname': this.$store.state.currentUserFullname,
          'currentUserEmail': this.$store.state.currentUserEmail,
          'users': JSON.stringify(this.allUsersSpecial),
          'groups': JSON.stringify(this.allGroups)
        }
        await this.$store.dispatch('getNewCaseId').then( async () => {
          await this.$store.dispatch('startProcess', payload).then( async () => {
            await this.$store.dispatch('getTask', this.instanceId).then( async () => {
              if(this.taskId && this.formKey) {
                await this.$store.dispatch('getCandidateGroups', this.taskId).then( async () => {
                  let canClaim = false;
                  let userGroups = this.$store.state.userGroups;
                  
                  if(this.candidateGroups.length > 0) {
                    for(let i = 0; i < this.candidateGroups.length; i++) {
                      if(userGroups.indexOf(this.candidateGroups[i]) !== -1) {
                        canClaim = true;
                      }
                    }
                  }
                  if(this.candidateUsers.length > 0) {
                    if(this.candidateUsers.indexOf(this.$store.state.currentUser) !== -1) {
                      canClaim = true;
                    }
                  }
                
                  if(canClaim) {
                    let data = {
                      'taskId': this.taskId,
                      'userId': this.$store.state.currentUser
                    }
                    await this.$store.dispatch('claimTask', data).then( async () => {
                      this.$store.commit('UPDATE_PROCESS_KEY', item.processKey);
                      this.$store.commit('UPDATE_PROCESS_VERSION', parseInt(item.version));
                      this.$store.commit('UPDATE_PROCESS_NAME', this.processName);
                      this.$store.commit('UPDATE_CASE_ID', this.newCaseId);

                      let payloadGet = {
                        'instanceId': this.instanceId,
                        'processId': this.processId,
                        'caseId': this.newCaseId,
                        'taskId': this.taskId,
                        'assignee': this.$store.state.currentUser
                      };
                      await this.$store.dispatch('getCaseStatus', payloadGet).then( () => {
                        let payloadSet = {
                          'instanceId': this.instanceId,
                          'opened': true,
                          'caseId': this.newCaseId,
                          'taskId': this.taskId,
                          'assignee': this.$store.state.currentUser
                        };
                        this.$store.dispatch('setCaseStatus', payloadSet);
                      });

                      this.$router.push({ name: 'ViewTask' });
                    });
                  }else {
                    this.snackSuccess();
                  }
                });
              }
            });
          });
        });
        this.caseLabel = '';
      },
      snackSuccess () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Case started successfully.'
      },
    },
  }
</script>
